<template>
  <ComponentsLayoutWithNavbar
    id="offers-for-lot"
    main_color="var(--color-main-green)">
    <template #breadcrumbs>
      <TenderBreadcrumbs
        :current="tenderLot.title || '–'"
        :loading="loading"/>
    </template>
    <template #main_content>
      <template v-if="loading">
        <v-skeleton-loader
          :boilerplate="true"
          class="mt-10 pr-8"
          :tile="true"
          type="heading"
          width="100%"/>
        <v-skeleton-loader
          :boilerplate="true"
          class="mt-3 pr-8"
          :tile="true"
          type="sentences"
          width="100%"/>
        <v-skeleton-loader
          :boilerplate="true"
          class="mt-4 main__green mt-5"
          :tile="true"
          type=" table-thead, table-tbody"
          width="100%"/>
      </template>
      <div v-else>
        <div class="h1-headline pt-2 text-left">
          {{ tenderLot.title || '–' }}
        </div>
        <div
          v-if="tenderLot.description "
          class="h6-text text-left">
          {{ tenderLot.description }}
        </div>
        <div class="h6-text text-left pt-3">
          {{ tender.category ? tender.category.code + ' ' + tender.category.title : '' }}
        </div>
        <div class="flex flex-between pt-5">
          <div class="h4-headline text-left">
            {{ filtred_items.length }} {{ $tc('Tenders.Proposals', filtred_items.length ) }}
          </div>
          <TooltipedBtn
            icon="graph"
            :text="$t('Tenders.HistoryOfLot')"
            :texted="$vuetify.breakpoint.lgAndUp"
            @click="$router.push({ name: 'bidsHistoryByLots', params: { tenderId: tender.tenderId, lotId: tenderLot.lotId, org: $route.params.org} })"/>
        </div>
        <v-skeleton-loader
          v-if="loading"
          :boilerplate="false"
          class="mt-4"
          :tile="false"
          type=" table-thead, table-tbody, table-tbody"
          width="100%"/>
        <OffersGroups
          v-else
          :key="bid_groups.length "
          ref="offers_table"
          :bid_groups="bid_groups"
          :bids="items"
          :critery-card="criteryCard"
          :tender="tender"
          :with_header="bid_groups.some(el => el.winners)"/>
      </div>
    </template>
    <template #nav_bar="{ mini }">
      <div
        v-show="!mini"
        class="offers-info">
        <LotInfoBar
          :item="tenderLot"
          :tender="tender"/>
        <HistoryTabs
          :item="tenderLot"
          type="LOT"/>
      </div>
      <div
        v-show="!mini"
        class=" d-flex justify-center">
        <BackToTenderBtn
          :tender-id="tender.tenderId"/>
      </div>
    </template>
  </ComponentsLayoutWithNavbar>
</template>

<script>
import BackToTenderBtn from 'components/tenders/BackToTenderBtn.vue'
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'
import LotInfoBar from 'components/tenders/tender page/LotInfoBar.vue'
import HistoryTabs from 'components/tenders/tender page/HistoryTabs.vue'
import TenderBreadcrumbs from 'components/tenders/TenderBreadcrumbs.vue'
import OffersGroups from 'components/tenders/tender page/OffersGroups.vue'
import ComponentsLayoutWithNavbar from 'pages/templates/ComponentsLayoutWithNavbar.vue'

import { snackbarMixin, filterSortMixin, modalMixin, tenderMixin } from 'mixins'
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'offersForLot',
  mixins: [ snackbarMixin, filterSortMixin, modalMixin, tenderMixin ],
  data() {
    return {
      sort_by: [],
      sort_desc: [],
      criteryCard: {},
      tenderLot: {},
      tender: {},
      loading: false,
      items_filter: [],
      filtred_items: [],
      currencies: []
    }
  },
  async created() {
    await this.$store.dispatch('setCurrencies')
      .then((result) => {
        this.currencies = result
      })
    await this.getItem()
  },
  computed: {
    ...mapGetters({
      user: 'GET_USER'
    }),
    items() {
      if ( !this.tender || !this.tender.bids) { return [] }
      return this.getBids(this.tender?.bids, this.tender).filter(bid => bid.lotId == this.tenderLot.lotId  && ['ACTIVE', 'DRAFT'].includes(bid.bidStatus))
    },
    filters() {
      return [
        {text: this.$t('Tenders.Supplier'), value: 'name', setFilter: true,},
        {text: this.$t('Tenders.FilingDate'), value: 'timeSupplyBids', setFilter: true,},
        {text: this.$t('Catalog.Price'), value: 'price', setFilter: true,}
      ]
    },
    bid_groups() {
      let groups = this.$_getGroupsByWinners(this.items)
      groups.forEach(gr => {
        gr.formatHeaders = (headers) => {
          if ( this.tender.tenderStatus?.id == 3 ) {
            headers[3].text = gr.winners ? this.$t('Tenders.SelectedQuantity') : this.$t('Tenders.ProposedAmount')
          }
          return headers
        }
      })
      return groups
    },
  },
  methods: {
    formatHeaders(headers) {
      return headers.filter(el => el.value != 'lotTitle')
    },
    /* snackbarOpen(selected) {
      return {
        name: 'lot-offers',
        elements: selected,
        item: this.tenderLot,
        tender: this.tender,
        callback: () => {
          selected = []
        }
      }
    }, */
    async getItem() {
      this.loading = true
      await this.$store.dispatch('getTenderItem', {id: this.$route.params.tenderId })
        .then(res => {
          this.tender = res
          this.tenderLot = this.tender.lots.find( lot => {
            return lot.lotId ==  +this.$route.params.lotId
          })
        })

      await this.$store.dispatch('infoAboutCriterionCard', {save: true, id: this.tender.criteriaCard}).then(res => this.criteryCard = res)

      this.loading = false
    },
    sortOrder() {
      let first = this.$t('Tenders.FirstLetter'),
        last = this.$t('Tenders.LastLetter'),
        order = this.sort_by[0] == 'provider' ?  this.sort_desc[0] : false

      return  ' ' + ( !order ? first + '–' + last : last + '–' + first)
    },
    applyFilters(filters) {
      this.items_filter = filters
      if (!filters?.length ) {
        this.filtred_items = this.items
        return
      }
      let filtredItems = this.items.filter( item =>  {
        let res, result = []
        filters.forEach( filter => {

          switch (filter?.title) {
          case 'name': {
            res = item.bidderInfo?.organizationName?.toLowerCase().includes(filter?.value?.toLowerCase())
            filter?.contain ? result.push(res) : result.push(!res)
            break
          }
          case 'price': {
            res = item.price == filter?.value
            filter?.contain ? result.push(res) : result.push(!res)
            break
          }
          case 'timeSupplyBids': {
            let itemDate = moment(item?.timeSupplyBids?.slice(0,10)).toDate().getTime(),
              dTo = Date.now(),
              dFrom = Date.now(),
              date = []

            if (itemDate == null) {
              result.push(false)
              break
            }
            if (filter?.search[0] != '' ) {
              dFrom =  moment(filter.search[0]).toDate().getTime()
              date.push(itemDate >= dFrom)
            }
            if (filter[1] != '' ) {
              dTo =  moment(filter[1]).toDate().getTime()
              date.push(itemDate <= dTo)
            }
            filter?.contain ? result.push(date.every(el => el)) : result.push(date.some(el => !el))
            break
          }
          }
        })
        return filters.mode ? result.every(el => el) : result.some(el => el)
      })
      this.filtred_items = filtredItems
    },
  },
  watch: {
    items() {
      this.applyFilters(this.items_filter)
    }
  },
  components: {
    LotInfoBar,
    HistoryTabs,
    OffersGroups,
    TooltipedBtn,
    BackToTenderBtn,
    TenderBreadcrumbs,
    ComponentsLayoutWithNavbar
  }
}
</script>
<style lang="scss" scoped>
.v-subheader {
  height: unset !important;
}
.divider {
  border: 1px solid black !important;
  margin: 2px 0;
}
.positions-count {
  font-size: 18px;
  text-align: start;
  font-weight: 500
}
.offer-info {
   div {
    text-align: start;
    font-size: 13px;
  }
}
// .offers-info {
// }

.nav-actions {
  border-top: 1px solid #E8E8E8 ;
  // position: absolute;
  height: 65px;
  max-height: 65px;
  bottom: 0;
  width: 100%;
  background-color: var(--white-color);
  &.to-comment{
    height: 155px;
    max-height: 155px;
  }
}
.sticky {
  position: sticky;
  z-index: 20;
}
.lot-main-info {
  top: 0;
  background-color: var(--white-color);
}

.offers-info {
  height: calc(100vh - 38px);
}
</style>
